import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';

import { LazyLoadEvent, CheckboxModule } from 'primeng';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { IPageResult } from '../../interfaces/page-result';
import { IVehicleType } from '../../interfaces/vehicle-type';
import { IVehicleTypeFilter } from '../../interfaces/vehicle-type-filter';
import { VehicleTypeService } from '../../services';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'vehicle-types',
  templateUrl: './manage-vehicle-type.component.html',
})
export class VehicleTypesComponent implements OnInit {
  public page: IPageResult<IVehicleType> = {
    items: [],
    total: 0,
  };

  public event: any;
  public filter: Subject<IVehicleTypeFilter>;
  public filterVal: IVehicleTypeFilter;
  public isLoaded: boolean = false;
  public displayDialog: boolean = false;
  public vehicle: IVehicleType;
  public newvehicle: boolean = false;
  public filterString: string;
  public newVehicleTypeForm: UntypedFormGroup;
  public name: UntypedFormControl;
  public description: UntypedFormControl;
  public isActive: UntypedFormControl;

  constructor(private vehicleTypeService: VehicleTypeService) {}

  ngOnInit() {
    this.filter = new Subject<IVehicleTypeFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next({ first: 0, rows: 10 });

    // set formGroup instance
    this.name = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
    );
    this.description = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
    );
    this.isActive = new UntypedFormControl(true, Validators.required);

    this.newVehicleTypeForm = new UntypedFormGroup({
      name: this.name,
      description: this.description,
      isActive: this.isActive,
    });
  }

  load(filter: IVehicleTypeFilter) {
    this.vehicleTypeService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  showDialogToAdd() {
    this.newvehicle = true;
    this.vehicle = {
      name: '',
      description: '',
      id: 0,
      isActive: true,
    };
    this.resetFormValues(this.vehicle);
    this.displayDialog = true;
  }

  save(formValues) {
    this.vehicle.name = formValues.name.trim();
    this.vehicle.description = formValues.description;
    this.vehicle.isActive = formValues.isActive;

    if (this.vehicle.name !== '') {
      this.vehicleTypeService.create(this.vehicle).then((res) => this.load(this.filterVal));
    }
    this.displayDialog = false;
  }

  close() {
    this.displayDialog = false;
  }

  resetFormValues(formValues) {
    this.newVehicleTypeForm.setValue({
      name: formValues.name,
      description: formValues.description,
      isActive: formValues.isActive,
    });
  }

  onRowSelect(event) {
    this.event = event;
  }

  onRowDblclick(item) {
    this.newvehicle = false;
    this.vehicle = this.cloneVehicle(item);
    this.resetFormValues(this.vehicle);
    this.displayDialog = true;
  }

  onEdit() {
    if (this.event !== undefined) {
      this.onRowDblclick(this.event);
    }
  }

  cloneVehicle(c: IVehicleType): IVehicleType {
    let vehicle = { id: 0, name: '', description: '', isActive: true };
    for (let prop in c) {
      vehicle[prop] = c[prop];
    }
    return vehicle;
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    // map grid lazy load event to filter
    var eventString = JSON.stringify(event);
    if (eventString === this.filterString) return;
    console.log(event);
    this.filter.next(event);
  }
}
